import { useQuery } from '@tanstack/react-query';
import { Endpoint } from '@/Config/api/endpoint';
import { SubscriptionApi } from '@/Domain/api/Subscription/Subscription.api';
import { SubscriptionPlansDto } from '@/Domain/api/Subscription/dto/SubscriptionPlans.dto';

export const useGetSubscriptionPlans = () => {
  const query = useQuery<SubscriptionPlansDto>({
    queryKey: [Endpoint.subscription.list],
    queryFn: () => SubscriptionApi.list(),
  });

  return { ...query };
};
